import $ from "jquery";
import "./modules/jquery.matchHeight";
import Swiper from "./modules/swiper";
import smoothScroll from "./modules/smoothScroll";

$(function () {
  $('.media-info-list ul li article h1 a').matchHeight();
  $('#top-media-list ul li h1 a').matchHeight();
  $('.media-info-list ul li article figure').matchHeight();
  $('#top-media-list ul li figure').matchHeight();
  $('.list-image-text li p').matchHeight();
});


const mainSlider = new Swiper('.main-slider .swiper-container', {
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.main-slider .swiper-container .swiper-pagination',
    clickable: true
  },
});

const newsSlider = new Swiper('.news-slider', {
  loop: true,
  speed: 500,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

function hamburgerMenu() {
  const button = document.querySelector('.sp-hamb-menu');
  const slideMenu = document.querySelector('.global-navigation');
  button.addEventListener('click', () => {
    slideMenu.classList.toggle('open');
    button.classList.toggle('open');
  }, {passive: true})
}


if (document.getElementById('top')) smoothScroll();
hamburgerMenu();

mainSlider.constructor;
newsSlider.constructor;

window.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    document.getElementsByTagName('html')[0].style.setProperty('scroll-behavior', 'smooth')
  }, 1000);
});